import {
  ColDef,
  ValueFormatterParams,
  ICellRendererParams,
} from "ag-grid-community";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { formatDate } from "utils/Date";
import { dateFilterParams } from "utils/AgGridFilter";
import { numberFormatter, statusValueFormatter } from "utils/Formatter/Global";
import CustomizedStatus from "components/Custom/CustomizedStatus";
import { typeValueFormatter } from "utils/Formatter/Logistic/Vehicle";
// import { formatNumber } from "utils/Global";
// import HeaderSelectAll from "components/UI/Modal/CheckedModal/HeaderSelectAll";
import { useVehicleTypeValues } from "hooks/Logistic/use-vehicle-type-options";
import { DT_STATUS_ALL } from "types/Logistic/deliveryTripStatus";

export const useDeliveryTripItemListColumnDefs = () => {
  const [columnDefs, setColumnDefs] = useState<ColDef[]>([]);
  const { fetchValues: fetchVehicleTypeValues } = useVehicleTypeValues();

  const { t } = useTranslation();
  useEffect(() => {
    setColumnDefs([
      //   {
      //     width: 100,
      //     checkboxSelection: true,
      //     headerComponent: HeaderSelectAll,
      //     headerComponentParams: {
      //       isAllSelected,
      //       isIndeterminate,
      //       onToggleAll,
      //     },
      //   },
      {
        field: "dt_unique_id",
        headerName: t("logistic.delivery_trip.unique_id"),
        filter: "agTextColumnFilter",
        // minWidth: 200,
        // flex: 1,
      },
      // {
      //   field: "customer_unique_id",
      //   filter: "agTextColumnFilter",
      //   suppressColumnsToolPanel: true,
      //   hide: true,
      // },
      {
        field: "dt_issue_date",
        headerName: t("date.issue_date"),
        filter: "agDateColumnFilter",
        filterParams: dateFilterParams,
        minWidth: 200,
        flex: 1,
        valueFormatter: (params: ValueFormatterParams) =>
          formatDate(params.value),
        sort: "desc",
      },
      {
        field: "dt_job_no",
        headerName: t("logistic.delivery_trip.job_no"),
        filter: "agTextColumnFilter",
      },
      {
        field: "dt_reference_unique_id",
        headerName: t("logistic.delivery_trip.reference_document_list"),
        filter: "agTextColumnFilter",
      },
      {
        field: "dt_customer_name",
        headerName: t("logistic.delivery_trip.customer_details.name"),
        filter: "agTextColumnFilter",
        minWidth: 200,
        flex: 1,
      },
      {
        field: "dt_vehicle_license_plate",
        headerName: t("logistic.delivery_trip.vehicle.license_plate"),
        filter: "agTextColumnFilter",
        minWidth: 200,
        flex: 1,
      },
      {
        field: "dt_vehicle_type",
        headerName: t("logistic.delivery_trip.vehicle.vehicle_type"),
        filter: "agSetColumnFilter",
        minWidth: 200,
        flex: 1,
        valueFormatter: (params: ValueFormatterParams) =>
          typeValueFormatter(params.value),
        filterParams: {
          values: async (params: any) => {
            params.success(await fetchVehicleTypeValues());
          },
          valueFormatter: (params: ValueFormatterParams) =>
            typeValueFormatter(params.value),
        },
      },
      {
        // 86d488a5h — the trip's price as it stands right now. The snapshot is
        // taken when the trip is added to the billing note, not here.
        field: "dt_fuel_price",
        headerName: t("logistic.delivery_trip.fuel_price"),
        filter: false,
        sortable: false,
        valueFormatter: (params: ValueFormatterParams) =>
          params.value === null || params.value === undefined
            ? "-"
            : numberFormatter(params.value),
        cellStyle: { display: "flex", justifyContent: "flex-end" },
        headerClass: "ag-end-header",
        minWidth: 150,
        flex: 1,
      },
      {
        field: "dt_aggrid_status",
        headerName: t("status.index"),
        minWidth: 200,
        flex: 1,
        cellRenderer: (params: ICellRendererParams<any, string>) => {
          if (params.value === "late") {
            return <CustomizedStatus status={params.data.dt_main_status} />;
          } else {
            return <CustomizedStatus status={params.value} />;
          }
        },
        cellStyle: {
          display: "flex",
          alignItems: "center",
        },
        filterParams: {
          values: DT_STATUS_ALL,
          valueFormatter: (params: ValueFormatterParams) =>
            statusValueFormatter(params.value),
        },
      },
      {
        field: "income_item_unique_id",
        headerName: "รหัสสินค้า",
        filter: "agTextColumnFilter",
        minWidth: 200,
        flex: 1,
      },
      {
        field: "income_item_name",
        headerName: "ชื่อสินค้า",
        filter: "agTextColumnFilter",
        minWidth: 200,
        flex: 1,
      },
      {
        field: "income_item_description",
        headerName: "รายละเอียด",
        filter: "agTextColumnFilter",
        minWidth: 200,
        flex: 1,
      },
      {
        field: "income_item_pre_vat_amount",
        headerName: "จำนวนเงิน",
        filter: "agNumberColumnFilter",
        valueFormatter: (params: ValueFormatterParams<any, any>) => {
          if (params.value) {
            return numberFormatter(params.value);
          } else return "";
        },
        minWidth: 200,
        flex: 1,
      },
    ]);
  }, [t, fetchVehicleTypeValues]);
  return columnDefs;
};
